import React, { useEffect, useState } from "react";
import ReadMode from "./ReadMode";
import { Header } from "./Header";
import { Button } from "./Button";
import { summarizeBoxFile } from "../services/api/apiService";

const MainContent: React.FC = () => {
    const [message, setMessage] = useState<string>("");
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [fileId, setFileId] = useState<string>("");
    const [fileExtension, setFileExtension] = useState<string>("");

    useEffect(() => {
        const params = new URLSearchParams(window.location.search);
        setFileId(params.get('file_id') ?? '');
        setFileExtension(params.get('file_extension') ?? '');
    }, []);

    const handleClick = async () => {
        setIsLoading(true);
        try {
            const summaryText = await summarizeBoxFile(fileId, fileExtension);
            setMessage(summaryText);
        } catch (error) {
            setMessage("Failed to generate summary." + error);
        }
        setIsLoading(false);
    };

    return (
        <div className="min-h-screen bg-slate-50 flex flex-col">
            <Header />

            <Button
                onClick={handleClick}
                label="Call CAi"
            />

            <div className="flex-grow flex flex-col overflow-hidden">
                {message ? (
                    <ReadMode message={message} isLoading={isLoading} />
                ) : (
                    <p></p>
                )}
            </div>
        </div>
    );
};

export default MainContent;
